
/**
 *  Module dependencies.
 */

import 'babel-polyfill'
import { decode } from 'he'
import Raven from 'raven-js'

/**
 * Global.
 */

window.segment = {}

/**
 * Scripts.
 */

const scripts = document.querySelectorAll('script.data')

/**
 * Load.
 */

for (let i = 0; i < scripts.length; i++) {
  const script = scripts[i]
  const namespace = script.getAttribute('data-namespace')
  const val = decode(script.innerHTML)
  const data = JSON.parse(val)
  window.segment[namespace] = data
}

/**
* Initialize and configure Raven
*/

// wrap in try to prevent raven from causing add'l exceptions...
try {
  const { APP_ENV, APP_VERSION, sentryClientKey } = window.segment
  if (process.env.NODE_ENV === 'production') {
    Raven.config(sentryClientKey).install()
    Raven.setEnvironment(APP_ENV)
    Raven.setRelease(APP_VERSION)
  }
} catch (e) {
  console.error(e)
}



// WEBPACK FOOTER //
// ./segment/index.js